import { TextareaAutosize } from "@material-ui/core";
import { Col, FormGroup, Label } from "reactstrap";
import styles from "./index.module.scss";

const TextareaField = ({value, label, onChange}) => {
    const handleTextChange = (e) => onChange(e.target.value);

    // Ensure value is never null - convert to empty string if needed
    const safeValue = value || "";

    return (
        <Col className="px-2 col-12">
            <FormGroup>
                <h5 className="mt-4">
                    <Label className={styles.label}>{label}</Label>
                </h5>
                <TextareaAutosize
                    minRows={5}
                    cols={130}
                    value={safeValue}
                    onChange={handleTextChange}
                    type="text"
                    className={styles.textArea}
                />
            </FormGroup>
        </Col>
    )
};
export default TextareaField;